import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { GovernanceProvider, GovModuleWorkspace, govRecordPath, type GovModule } from './olivium/governance'

/**
 * V2 Olivium governance module — list route wrapper.
 *
 * Registered per module + auth-gated (see router.tsx), e.g.:
 *   /square/command-center/olivium/audit
 *
 * Wraps the module list in the GovernanceProvider (local-session ledger,
 * persisted to sessionStorage so edits survive navigation to a record and back).
 */
export default function SquareCodeOliviumModuleRoute({ module }: { module: GovModule }) {
  const navigate = useNavigate()
  return (
    <GovernanceProvider>
      <GovModuleWorkspace
        module={module}
        onOpenRecord={(m, id) => navigate(govRecordPath(m, id))}
        onOpenPath={(to) => navigate(to)}
        onHome={() => navigate(COMMAND_CENTER_ROOT)}
      />
    </GovernanceProvider>
  )
}
